module.exports = __webpack_public_path__ + "static/part-0-b9999ec785b2c3bc6b8d3ef5d3537538.svg";